module.exports = __webpack_public_path__ + "static/media/TempSTEMACES.90e207c9.logo";